import { CNPJ_LENGTH, CPF_LENGTH, EMAIL_MAX_LENGTH } from 'common/constants';
import { cpf as CPF } from 'cpf-cnpj-validator';

const TEXT_MASK = '*'.repeat(EMAIL_MAX_LENGTH);

export const getPixMask = (value: string | null | undefined) => {
  if (!value) {
    return TEXT_MASK;
  }

  const raw = value.toString();

  if (raw.includes('@')) {
    return TEXT_MASK;
  }

  const digits = raw.replace(/\D/g, '');
  const length = digits.length;

  if (length === 0) {
    return TEXT_MASK;
  }

  if (length === CPF_LENGTH) {
    if (CPF.isValid(digits)) {
      return '000.000.000-00*';
    }

    return '(00) 00000-0000*';
  }

  if (length === CNPJ_LENGTH) {
    return '00.000.000/0000-00*';
  }

  return TEXT_MASK;
};
